// extracted by mini-css-extract-plugin
module.exports = {"uploadMediaContainer":"UploadMedia_uploadMediaContainer__tIlUN","uploadButton":"UploadMedia_uploadButton__34hTv"};